module.exports = __webpack_public_path__ + "static/media/ECI88_HDeposit.e5793692.png";